import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import FluidSpacer from '@/components/base/fluid-spacer'
import Form from '@/components/base/form'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type LeadGenerationProductFormProps = HTMLAttributes<HTMLDivElement> & {}

const LeadGenerationProductForm = ({
  className,
  ...props
}: LeadGenerationProductFormProps) => {
  const { strings } = useStore()
  return (
    <>
      <FluidSpacer variant="top" />

      <Section className={cn('dark relative', className)} {...props}>
        <Container className="pt-s-spacer-xl md:pt-d-spacer-xl">
          <Grid className="gap-y-spacing-lg">
            <div
              className={cn(
                'col-span-2 md:col-span-6 lg:col-span-12',
                'flex flex-col gap-y-spacing-xs'
              )}
            >
              {strings?.products?.form_title ? (
                <Typography variant="h4" component="h2">
                  {strings.products.form_title}
                </Typography>
              ) : null}

              {strings?.products?.form_paragraph ? (
                <Typography variant="regular" paragraph>
                  {strings.products.form_paragraph}
                </Typography>
              ) : null}

              {strings?.products?.form?.id ? (
                <Form
                  form_id={strings.products.form.id}
                  fields={strings.products.form.fields}
                  submit={strings.products.form.button.text}
                  theme="dark"
                />
              ) : null}
            </div>
          </Grid>
        </Container>
      </Section>
    </>
  )
}

export default LeadGenerationProductForm
